import React from 'react';
import { Form, InputGroup, Col } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import { FastField, Field } from 'formik'; // must use Field so that ColorPickerButton of  inputGroupPrepend can re-render
import PropTypes from 'prop-types';
import { formLabel } from '~/utils/helpers';

const FormText = ({ as, sm, name, inputGroupPrepend, className, isLabelHidden, asyncApiCall, inline, label }) => {
    return (
        <Field
            name={name}
            validate={asyncApiCall}
        >
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = meta.touched && !isValid;
                field.value = field.value ?? ''; //this is to avoid "Warning: Select elements must be either controlled or uncontrolled" (as explained: https://github.com/Shopify/polaris/issues/98#issuecomment-309243906)

                return (
                    <Form.Group
                        as={as}
                        sm={sm}
                        className={className}
                    >
                        {!isLabelHidden && (
                            <Form.Label className={inline ? 'col-sm-3 col-form-label' : ''}>
                                {label ? label : formLabel(name)}
                            </Form.Label>
                        )}
                        <InputGroup className={inline ? 'col-sm-9' : ''}>
                            {inputGroupPrepend}

                            <Form.Control
                                {...field}
                                type={'text'}
                                placeholder={isLabelHidden ? formLabel(name) : ''}
                                isValid={form.touched[field.name] && isValid}
                                isInvalid={isInvalid}
                                onBlur={(e) => {
                                    form.setFieldValue(name, e.target.value);
                                    form.handleBlur(e);
                                }}
                            />
                            <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                );
            }}
        </Field>
    );
};

FormText.defaultProps = {
    className: '',
    inputGroupPrepend: null,
    as: Col,
    sm: 2,
    isLabelHidden: false,
    props: null,
    asyncApiCall: null,
    inline: false,
};
FormText.propTypes = {
    as: PropTypes.elementType,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    inputGroupPrepend: PropTypes.node,
    isLabelHidden: PropTypes.bool,
    inline: PropTypes.bool,
    props: PropTypes.object,
    asyncApiCall: PropTypes.func,
};
export default FormText;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
